<div class="wrapper pt-2">
  <div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-2 ps-2">
      <div class="container-fluid">
        <div class="default_class">
          <div class="content-wrapper p-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card rounded mb-2">
                    <div class="card-header bg-white border-0">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 class="mb-0">Application</h5>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive newtable mb-2">
                        <table class="table table-sm table-striped" style="white-space: nowrap">
                          <thead>
                            <tr>
                              <th>Programme</th>
                              <th>Application Status</th>
                              <th>Action</th>
                              <th *ngIf="isPaid">Application Form</th>
                              <th *ngIf="tenantCode != '88968955' && aprvId == 4">
                                Payment
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of userData">
                              <td>
                                {{ item.course_name }}
                              </td>
                              <td>
                                <button class="btn btn-sm btn-orange">
                                  {{ item.application_status }}</button><br />
                                <a href="javascript:" style="cursor: pointer; font-size: small"
                                  *ngIf="item.application_status == 'FOLLOW UP'" (click)="showComments(item,1)">View
                                  Comments</a>
                              </td>
                              <td>
                                <button class="btn btn-sm btn-info" *ngIf="item.application_status == 'FOLLOW UP'"
                                  (click)="edit(item.course_id)">
                                  Edit
                                </button>
                                <button class="btn btn-sm btn-info" *ngIf="
                                    item.application_status ==
                                    'PENDING SUBMISSION'
                                  " (click)="gotoregform(item)">
                                  Resume
                                </button>
                              </td>
                              <td>
                                <button class="btn btn-sm btn-info" data-bs-target="#applicationForm"
                                  *ngIf="isPaid == 2" (click)="getUserDetails(item, true)" data-bs-toggle="modal">
                                  View
                                </button>
                              </td>
                              <td *ngIf="tenantCode != '88968955'">
                                <span *ngIf="aprvId == 4">
                                  <button class="btn btn-sm btn-info" *ngIf="makepayment" (click)="makePayment()">
                                    Make Payment
                                  </button>
                                </span>

                                <p *ngIf="amountPaid"><b>Enrolled</b></p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="card rounded pt-4">
                    <div class="card-header bg-white border-0">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 class="mb-0">My Admission</h5>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive newtable mb-2">
                        <table class="table table-sm table-striped" style="white-space: nowrap">
                          <thead>
                            <tr>
                              <th>Programme Name</th>
                              <th>Admission Letter</th>
                              <th *ngIf="isShowRejected">Comments/Status</th>
                              <th>Acceptance</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of table">
                              <td>
                                {{ item.COURSE_NAME }}
                              </td>
                              <td>
                                <button class="btn btn-sm btn-orange" *ngIf="!isSubmitDisabled(item.IS_SUBMIT)"
                                  (click)="openAdmissionLtr(item)">
                                  Download
                                </button>
                              </td>
                              <td *ngIf="isShowRejected">
                                <i class="bi bi-chat-left-text" (click)="showComments(item,2)"
                                  *ngIf="item.ADMISSIONREJECTED_COMMENTS"></i>&nbsp;
                                {{item.STATUS_NAME}}
                              </td>
                              <td>
                                <span *ngIf="item.IS_SUBMIT != 10" style="display: flex">
                                  <button class="btn btn-sm btn-info" *ngIf="
                                      item.APPL_PAYDET_ISPAID == 2 &&
                                      item.IS_APPROVED == 3
                                    " (click)="payment(5, 6, item.COURSE_ID)">
                                    Accept & Download
                                  </button>
                                  <button class="btn btn-sm btn-secondary" *ngIf="
                                      item.APPL_PAYDET_ISPAID == 2 &&
                                      item.IS_APPROVED == 3
                                    " (click)="
                                      AcceptMthdForAdmission(
                                        10,
                                        5,
                                        item.COURSE_ID
                                      )
                                    ">
                                    Reject
                                  </button>
                                  <button disabled *ngIf="
                                      (item.IS_APPROVED == 4 &&
                                        item.APPL_PAYDET_ISPAID == 2) ||
                                      item.IS_SUBMIT == 11
                                    " class="btn btn-sm btn-orange">
                                    Accepted
                                  </button>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <app-my-admission *ngIf="myAdmission"></app-my-admission> -->
<app-student-available-programs [status]="showPopup"
  *ngIf="roleId == 3 || roleName?.toLowerCase() === 'alumni'"></app-student-available-programs>

<div class="modal" data-backdrop="static" data-keyboard="false" id="applicationForm">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Application Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="Closemodal"
          (click)="closeApplicationPopup()"></button>
      </div>
      <div class="modal-body">
        <div id="printtable" class="pt-5">
          <table width="980" cellspacing="0" cellpadding="0" style="margin: auto">
            <tbody>
              <tr>
                <td>
                  <table width="980" border="0" cellspacing="10" cellpadding="0">
                    <tbody>
                      <tr>
                        <td height="" style="text-align: center" valign="middle">
                          <img src="../../../../assets/img/ouk-logo-new.png" width="200" alt="" />
                        </td>
                        <td rowspan="4">
                          <div class="pt-2 d-flex" style="width: 150px; height: 150px">
                            <img [src]="userDetails?.result?.upload_4" class="img-fluid m-auto"
                              style="margin: auto; max-height: 100%" alt="" />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">&nbsp;</td>
                      </tr>
                      <tr>
                        <td style="text-align: center">
                          <table width="100%">
                            <tr>
                              <td width="35%">
                                <p style="
                                    margin: 0px;
                                    font-size: 12px !important;
                                  ">
                                  <b>P.O. BOX</b> 2440-00606 NAIROBI, KENYA
                                </p>
                              </td>
                              <td width="35%">
                                <p style="
                                    margin: 0px;
                                    font-size: 12px !important;
                                  ">
                                  <b>TELEPHONE:</b> 0202000211/0202000212
                                </p>
                              </td>
                              <td width="30%">
                                <p style="
                                    margin: 0px;
                                    font-size: 12px !important;
                                  ">
                                  <b>EMAIL:</b> admissions&#64;ouk.ac.ke
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">&nbsp;</td>
                      </tr>
                      <tr>
                        <td style="text-align: center">
                          <h4 style="
                              margin-top: 0;
                              margin-bottom: 10px;
                              font-weight: 600;
                            ">
                            OUK Admissions Office
                          </h4>
                          <h5 style="color: #fe7f50; font-weight: 500">
                            STUDENT APPLICATION ONLINE FORM
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td colspan="2" style="padding: 10px">
                  <table width="100%" border="0" cellspacing="0" cellpadding="6" style="font-size: 13px">
                    <tbody>
                      <tr>
                        <td colspan="6" style="
                            border-bottom: 1px dashed #333;
                            font-size: 13px;
                          ">
                          <h5><b>(A) PROGRAM SELECTION</b></h5>
                        </td>
                      </tr>
                      <tr>
                        <td><b>Application Type</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{ userDetails?.result?.course_type_name }}
                        </td>
                        <td><b>Programme</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>{{ userDetails?.result?.course_name }}</td>
                      </tr>

                      <tr *ngIf="userDetails?.result?.is_cluster">
                        <td colspan="6">
                          <table class="table-bdr" width="100%" border="1" cellspacing="0" cellpadding="6">
                            <tbody>
                              <tr>
                                <th>Programme Cluster</th>
                                <th>Subject Name(eg MAT)</th>
                                <th>Grade obtained</th>
                              </tr>
                              <tr>
                                <td>CLUSTER SUBJECT 1</td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT1_NAME
                                  }}
                                </td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT1_GRADE
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>CLUSTER SUBJECT 2</td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT2_NAME
                                  }}
                                </td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT2_GRADE
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>CLUSTER SUBJECT 3</td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT3_NAME
                                  }}
                                </td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT3_GRADE
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>CLUSTER SUBJECT 4</td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT4_NAME
                                  }}
                                </td>
                                <td>
                                  {{
                                  userDetails?.get_cluster
                                  ?.CLUSTER_SUBJECT4_GRADE
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td><b>English</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{
                          userDetails?.get_cluster?.ENGLISH_PROFICIENCY_NAME
                          }}
                        </td>
                        <td><b>Computing Skills</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{
                          userDetails?.get_cluster
                          ?.COMPUTING_SKILLS_PROFICIENCY_NAME
                          }}
                        </td>
                      </tr>

                      <!-- <tr>
                                 
                                      <td><b>Are you applying for Recognition of Prior Learning (RPL)?</b>
                                      </td>
                                      <td width="2%" style="text-align: center;">:</td>
                                      <td>{{userDetails?.get_cluster?.IS_RPL == true ? 'Yes' : 'No'}}</td>
                                  </tr> -->
                    </tbody>
                  </table>
                  <table width="100%" border="0" cellspacing="0" cellpadding="6"
                    style="border-top: 2px dashed #333; font-size: 13px">
                    <tbody>
                      <tr>
                        <td colspan="6" style="
                            border-bottom: 1px dashed #333;
                            font-size: 13px;
                          ">
                          <h5><b>(B) PERSONAL DETAILS</b></h5>
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>First Name</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.firstname }}
                        </td>
                        <td width="24%"><b>Middle Name</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.middlename }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Surname</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.lastname }}</td>
                        <td><b>Country of Residence</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>{{ userDetails?.result?.country_of_residence }}</td>
                      </tr>

                      <tr>
                        <td *ngIf="userDetails?.result?.counties_id != 0">
                          <b>County</b>
                        </td>
                        <td *ngIf="userDetails?.result?.counties_id != 0" width="2%" style="text-align: center">
                          :
                        </td>
                        <td *ngIf="userDetails?.result?.counties_id != 0">
                          {{ userDetails?.result?.counties_name }}
                        </td>

                        <td><b>Mobile Number 1</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{ userDetails?.result?.mobileno_code_name }}
                          {{ userDetails?.result?.mobileno }}
                        </td>
                        <!-- <td *ngIf="userDetails?.result?.counties_id !=0"><b>Sub County</b></td>
                                              <td *ngIf="userDetails?.result?.counties_id !=0" width="2%"
                                                  style="text-align: center;">:</td>
                                              <td *ngIf="userDetails?.result?.counties_id !=0">
                                                  {{userDetails?.result?.sub_counties_name}}</td> -->

                        <!-- <td><b>Postal Address</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.postal_address}} </td> -->
                      </tr>
                      <tr>
                        <!-- <td *ngIf="userDetails?.result?.counties_id !=0"><b>Constituency</b>
                                              </td>
                                              <td *ngIf="userDetails?.result?.counties_id !=0" width="2%"
                                                  style="text-align: center;">:</td>
                                              <td *ngIf="userDetails?.result?.counties_id !=0">
                                                  {{userDetails?.result?.con_counties_name}}</td> -->
                      </tr>
                      <!-- <tr>
                                              <td><b>Physical Address</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.physical_address}}</td>
                                              <td><b>Postal Code</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.postal_code}}</td>
                                          </tr> -->

                      <tr>
                        <!-- <td><b>Town/City</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.nearest_town}}</td> -->

                        <td width="24%"><b>Current Email</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.username }}</td>

                        <td width="24%"><b>Gender</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.gender_name }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Date of Birth</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.dob }}</td>
                        <td width="24%"><b>Disability</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.isdisability_name }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES'
                          ">
                          <b>Type Of Disability</b>
                        </td>
                        <td width="2%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES'
                          " style="text-align: center">
                          :
                        </td>
                        <td width="24%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES'
                          ">
                          {{ userDetails?.result?.typeofdisability_name }}
                        </td>
                        <td width="24%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES' &&
                            userDetails?.result?.typeofdisability_name ==
                              'OTHER'
                          ">
                          <b>Disability Description</b>
                        </td>
                        <td width="2%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES' &&
                            userDetails?.result?.typeofdisability_name ==
                              'OTHER'
                          " style="text-align: center">
                          :
                        </td>
                        <td width="24%" *ngIf="
                            userDetails?.result?.isdisability_name == 'YES' &&
                            userDetails?.result?.typeofdisability_name ==
                              'OTHER'
                          ">
                          {{ userDetails?.result?.disability_description }}
                        </td>
                      </tr>
                      <!-- <tr>
                                            
                                              <td><b>Mobile Number 2</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.mobileno2_code_name}}
                                                  {{userDetails?.result?.mobileno2}}</td>

                                          </tr> -->

                      <!-- <tr>
                                              <td colspan="6" style="border-bottom:1px dashed #333; font-size:13px;">
                                                  <h5><b>(C) BIOGRAPHICAL INFORMATION</b></h5>
                                              </td>
                                          </tr> -->

                      <!-- <tr>
                                              <td width="24%"><b>Marital Status</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td width="24%">{{userDetails?.result?.maritalstatus_name}}</td>
                                              <td width="24%"><b>Birth Country</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td width="24%">{{userDetails?.result?.birth_country}}</td>
                                          </tr> -->
                      <!-- <tr>
                                              <td width="24%"><b>Orphan</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td width="24%">{{userDetails?.result?.orphan
                                                  ==1?'YES':userDetails?.result?.orphan ==2?'NO':'Do Not Wish To
                                                  Disclose'}}</td>
                                          </tr> -->

                      <tr>
                        <!-- <td><b>Nationality</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.nan_code}}</td> -->
                      </tr>
                      <!-- <tr>

                                              <td><b>Identification Document Type</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.id_passport_type_name}}</td>
                                              <td><b>{{userDetails?.result?.id_passport_type_name}}</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td colspan="4">{{userDetails?.result?.id_passport}}</td>
                                          </tr> -->
                    </tbody>
                  </table>
                  <!-- <table width="100%" border="0" cellspacing="0" cellpadding="6"
                                      style="font-size:13px;">
                                      <tbody>
                                          <tr>
                                              <td colspan="6" style="border-bottom:1px dashed #333; font-size:13px;">
                                                  <h5><b>(C) Next of Kin/Emergency Contact :</b></h5>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><b>Full Name</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.name_of_emergency}}</td>
                                              <td><b>Relationship</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.relationshipname_of_emergency_name}}</td>
                                          </tr>
                                          <tr>
                                              <td><b>Telephone</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.emergency_mobileno_code_name}}
                                                  {{userDetails?.result?.mobile_no_emergency}}</td>
                                              <td><b>Email Address</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.emailid_of_emergency}}</td>
                                          </tr>
                                          <tr>
                                              <td><b>Postal Address</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.address_of_emergency}}</td>
                                              <td><b>Postal Code</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.postalcode_of_emergency}}</td>

                                          </tr>
                                          <tr>
                                              <td><b>City/Town</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.
                                                  nearest_town}}</td>
                                              <td><b>Country</b></td>
                                              <td width="2%" style="text-align: center;">:</td>
                                              <td>{{userDetails?.result?.emergency_country}}</td>

                                          </tr>
                                          <tr>

                                              <td *ngIf="userDetails?.result?.counties_id_of_emergency !=0">
                                                  <b>County</b>
                                              </td>
                                              <td *ngIf="userDetails?.result?.counties_id_of_emergency !=0" width="2%"
                                                  style="text-align: center;">:</td>
                                              <td *ngIf="userDetails?.result?.counties_id_of_emergency !=0">
                                                  {{userDetails?.result?.counties_name_of_emergency}}</td>

                                          </tr>
                                      </tbody>
                                  </table> -->
                  <table width="100%" border="0" cellspacing="0" cellpadding="6"
                    style="border-bottom: 1px dashed #333; font-size: 13px">
                    <tbody>
                      <tr></tr>
                      <tr style="border-bottom: 0px dashed #333; font-size: 13px">
                        <td colspan="6">
                          <h5><b>(C) PREVIOUS EDUCATION DETAILS :</b></h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngFor="let item of userDetails?.lst">
                    <table *ngIf="[2, 7, 5, 4, 6].includes(apptype)" width="100%" border="1" cellspacing="0"
                      cellpadding="6">
                      <tbody>
                        <tr>
                          <td width="24%"><b> Awarding Institution </b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Country of Institution</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.EDUCATION_COUNTRY }}</td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Start Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.FROM_PERIOD | date : "yyyy" }}
                          </td>
                          <td width="24%"><b>End Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.TO_PERIOD | date : "yyyy" }}
                          </td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Degree Obtained</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.DEGREE_OBTAINED }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table *ngIf="apptype == 1" width="100%" border="1" cellspacing="0" cellpadding="6">
                      <tbody>
                        <tr>
                          <td width="24%"><b>Institution Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Country</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.EDUCATION_COUNTRY }}</td>
                        </tr>

                        <tr>
                          <td width="24%">
                            <b>Examination Number e.g. KCSE index number</b>
                          </td>

                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.EXAM_REG_NO }}</td>
                          <td width="24%"><b>Qualifications Attained</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.QUALIFICATION }}</td>
                        </tr>
                        <tr>
                          <td width="24%"><b>End Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item?.TO_PERIOD | date : "yyyy" }}
                          </td>
                          <td width="24%"><b>Mean Grade</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.GRADE }}</td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                  <table *ngIf="apptype == 1" width="100%" border="0" cellspacing="0" cellpadding="6"
                    style="font-size: 13px">
                    <tbody>
                      <tr>
                        <td>
                          <b>Are you applying for Recognition of Prior Learning
                            (RPL)?</b>
                        </td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{
                          userDetails?.rpl?.[0]?.IS_RPL == true ? "Yes" : "No"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngFor="let item of userDetails?.rpl">
                    <table *ngIf="userDetails?.rpl[0]?.IS_RPL == true" width="100%" border="1" cellspacing="0"
                      cellpadding="6">
                      <tbody>
                        <tr>
                          <td width="24%"><b>Institution Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Country</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.EDUCATION_COUNTRY }}</td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Qualifications Attained</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{
                            item?.QUALIFICATION_ID == 1
                            ? "Certificate"
                            : item.QUALIFICATION_ID == 2
                            ? "Diploma"
                            : "RPL Certification"
                            }}
                          </td>
                          <td width="24%"><b>End Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item?.TO_PERIOD | date : "yyyy" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- <div *ngFor="let item of userDetails?.lst">
                    <table
                      *ngIf="[2, 7, 5, 4, 6].includes(apptype)"
                      width="100%"
                      border="1"
                      cellspacing="0"
                      cellpadding="6"
                    >
                      <tbody>
                        <tr>
                          <td width="24%"><b> Awarding Institution </b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Country of Institution</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.EDUCATION_COUNTRY }}</td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Start Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.FROM_PERIOD | date : "yyyy" }}
                          </td>
                          <td width="24%"><b>End Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.TO_PERIOD | date : "yyyy" }}
                          </td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Degree Obtained</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.DEGREE_OBTAINED }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      *ngIf="userDetails?.rpl[0]?.IS_RPL"
                      width="100%"
                      border="1"
                      cellspacing="0"
                      cellpadding="6"
                    >
                      <tbody>
                        <tr>
                          <td width="24%"><b>Institution Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Country</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.EDUCATION_COUNTRY }}</td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Qualifications</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.QUALIFICATION }}</td>
                          <td width="24%"><b>End Year</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item?.TO_PERIOD | date : "yyyy" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                  <table width="100%" border="0" cellspacing="0" cellpadding="6" *ngIf="
                      isRecommondations &&
                      userDetails?.lst_recommandations?.length > 0
                    ">
                    <tbody>
                      <tr style="border-bottom: 1px dashed #333; font-size: 13px">
                        <td colspan="6">
                          <h5>
                            <b>({{
                              userDetails?.lst_recommandations.length
                              ? "D"
                              : ""
                              }}) RECOMMENDATIONS :</b>
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngFor="
                      let item of userDetails?.lst_recommandations;
                      let index = index
                    ">
                    <table width="100%" border="1" cellspacing="0" cellpadding="6" *ngIf="isRecommondations">
                      <b style="color: #f47d52">Referre {{ index }}</b>
                      <tbody>
                        <tr>
                          <td width="24%"><b>Full Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.NAME }}</td>
                          <td width="24%"><b>Institution</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.ORGANIZATION }}</td>
                        </tr>
                        <tr>
                          <td width="24%"><b>Country</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item?.COUNTRY_NAME }}</td>
                          <td width="24%"><b>Mobile Number</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item?.COUNTRY_CONNECTING_CODE }}
                            {{ item?.MOBILE_NUMBER }}
                          </td>
                        </tr>

                        <tr>
                          <td width="24%"><b>Recommender email</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%" colspan="4">
                            {{ item?.EMAIL_ADDRESS }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <table width="100%" border="0" cellspacing="0" cellpadding="6">
                    <tbody>
                      <tr style="border-bottom: 1px dashed #333; font-size: 13px">
                        <td colspan="6">
                          <h5>
                            <b>
                              ({{
                              !isRecommondations ||
                              !userDetails?.lst_recommandations?.length
                              ? "D"
                              : "E"
                              }}) REFERRAL :
                            </b>
                          </h5>
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Referral Code</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.referral_code }}
                        </td>
                        <td width="24%"><b>Referred by</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.ref_name }}</td>
                      </tr>
                      <tr>
                        <span *ngIf="userDetails?.result?.referral_platform_id == 8">
                          <td width="24%"><b>Description</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ userDetails?.result?.referral_name }}
                          </td>
                        </span>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="footer float-end pt-2">
            <button id="Closemodal" class="btn btn-danger" data-bs-dismiss="modal" (click)="closeApplicationPopup()">
              Close</button>&nbsp;&nbsp;
            <button class="btn btn-save" (click)="downloadForm('application')">
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" id="commentsModel">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Comments</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <h6>{{ userComments }}</h6>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
          Close
        </button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" id="editPopup">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <!-- (click)="closeRegistrationPopup(false)" -->
      </div>
      <div class="modal-body">
        <div class="stepper">
          <div *ngFor="let step of steps; index as i" class="step" [class.active]="i === currentStep"
            [class.completed]="i < currentStep">
            <div class="step-circle" (click)="goToStep(i)" [class.disabled]="i > currentStep">
              {{ i + 1 }}
            </div>
            <div class="step-label">{{ step.label }}</div>
            <div class="step-line" *ngIf="i < steps.length - 1"></div>
          </div>
        </div>

        <!-- Step Content -->
        <div class="step-content">
          <ng-container *ngIf="currentStep === 0">
            <!-- Program Information Form -->
            <form>
              <form class="form-container cst_1 cstm_stepper" [formGroup]="signUpForm">
                <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                  Fill in your programme selection
                  <strong>Note: Fields marked with an asterisk (<span class="text-danger">*</span>) are
                    mandatory</strong>
                </div>
                <h6 class="mb-2 mt-3 title_stepper">
                  What would you like to study?
                </h6>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="firstName" class="form-label">Application Type
                      <span class="text-danger">*</span></label>
                    <select [(ngModel)]="apptype" class="form-select" (change)="
                        applicationType($any($event.target).value);
                        getQualificationAttained()
                      " formControlName="APPLICATION_TYPE" aria-label="Default select example">
                      <option value="0">Select</option>
                      <option *ngFor="let item of applicationTypes" [value]="item.COURSE_TYPE_ID">
                        {{ item.COURSE_TYPE_NAME }}
                      </option>
                    </select>

                    <!-- <span class="text-blue"
                      ><small>(e.g. Undergraduate or Postgraduate)</small></span
                    > -->
                  </div>
                  <div class="col-md-4">
                    <label for="firstName" class="form-label">Programme <span class="text-danger">*</span></label>
                    <select [(ngModel)]="courseId" (change)="loadClusterDetails($any($event.target).value)"
                      [ngModelOptions]="{ standalone: true }" class="form-select">
                      <option value="">Select</option>
                      <option *ngFor="let item of courseList" [value]="item.COURSE_ID">
                        {{ item.COURSE_NAME }}
                      </option>
                    </select>
                  </div>
                </div>
                <div *ngIf="clusters">
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-bordered table-bdr">
                        <tr>
                          <th>Programme Cluster</th>
                          <th>Subject Name(eg MAT)</th>
                          <th>Grade obtained</th>
                        </tr>
                        <tr>
                          <td>CLUSTER SUBJECT 1</td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT1_NAME">
                              <option value="">Select</option>
                              <option *ngFor="let item of clusterDropdowns[0]" [value]="item.CLUSTERDTL_ID">
                                {{ item.CLUSTER_SUBJECT_NAME }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT1_GRADE">
                              <option value="">Select</option>
                              <option *ngFor="let item of ClusterGradeList" [value]="item.CLUSTER_GRADE_ID">
                                {{ item.CLUSTER_GRADE_NAME }}
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>CLUSTER SUBJECT 2</td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT2_NAME">
                              <option value="">Select</option>
                              <option *ngFor="let item of clusterDropdowns[1]" [value]="item.CLUSTERDTL_ID">
                                {{ item.CLUSTER_SUBJECT_NAME }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT2_GRADE">
                              <option value="">Select</option>
                              <option *ngFor="let item of ClusterGradeList" [value]="item.CLUSTER_GRADE_ID">
                                {{ item.CLUSTER_GRADE_NAME }}
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>CLUSTER SUBJECT 3</td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT3_NAME">
                              <option value="">Select</option>
                              <option *ngFor="let item of clusterDropdowns[2]" [value]="item.CLUSTERDTL_ID">
                                {{ item.CLUSTER_SUBJECT_NAME }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT3_GRADE">
                              <option value="">Select</option>
                              <option *ngFor="let item of ClusterGradeList" [value]="item.CLUSTER_GRADE_ID">
                                {{ item.CLUSTER_GRADE_NAME }}
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>CLUSTER SUBJECT 4</td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT4_NAME">
                              <option value="">Select</option>
                              <option *ngFor="let item of clusterDropdowns[3]" [value]="item.CLUSTERDTL_ID">
                                {{ item.CLUSTER_SUBJECT_NAME }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select class="form-select" formControlName="CLUSTER_SUBJECT4_GRADE">
                              <option value="">Select</option>
                              <option *ngFor="let item of ClusterGradeList" [value]="item.CLUSTER_GRADE_ID">
                                {{ item.CLUSTER_GRADE_NAME }}
                              </option>
                            </select>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <h6 class="mb-2 mt-3 title_stepper">Proficiency</h6>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="firstName" class="form-label">English <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="ENGLISH_PROFICIENCY">
                      <option value="0">Select Level</option>
                      <option value="1">Beginner</option>
                      <option value="2">Intermediate</option>
                      <option value="3">Advanced</option>
                      <option value="4">Mastery</option>
                    </select>

                    <span class="text-blue small">(proficiency level in both speaking and writing)</span>
                  </div>
                  <div class="col-md-4">
                    <label for="firstName" class="form-label">Computing Skills
                      <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="COMPUTING_SKILLS_PROFICIENCY">
                      <option value="0">Select Level</option>
                      <option value="1">Beginner</option>
                      <option value="2">Intermediate</option>
                      <option value="3">Advanced</option>
                      <option value="4">Mastery</option>
                    </select>
                    <span class="text-blue small">(describe your computer handling skills)</span>
                  </div>
                </div>
              </form>

              <div class="text-end">
                <button type="submit" class="btn btn-primary" (click)="saveProgramData(signUpForm)">
                  Next
                </button>
              </div>
            </form>
          </ng-container>
          <!-- ----Personal details----- -->
          <ng-container *ngIf="currentStep === 1">
            <!-- Personal Information Form -->
            <form>
              <form class="form-container cst_1 cstm_stepper" [formGroup]="signUpForm">
                <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                  Fill in your personal details
                  <strong>Note: Fields marked with an asterisk (<span class="text-danger">*</span>) are
                    mandatory</strong>
                </div>
                <h6 class="mb-2 mt-3 title_stepper">Name</h6>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="firstName" class="form-label">First Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="firstName" placeholder="First Name"
                      formControlName="FIRSTNAME" onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                  </div>
                  <div class="col-md-4">
                    <label for="middleName" class="form-label">Middle Name</label>
                    <input type="text" class="form-control" id="middleName" placeholder="Middle Name"
                      formControlName="MIDDLENAME" onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                  </div>
                  <div class="col-md-4">
                    <label for="lastName" class="form-label">Surname <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="lastName" placeholder="Surname"
                      formControlName="LASTNAME" onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                  </div>
                </div>

                <h6 class="mb-2 mt-3 title_stepper">
                  Biographical Information
                </h6>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="gender" class="form-label">Gender <span class="text-danger">*</span></label>
                    <select class="form-select" id="gender" formControlName="GENDER">
                      <option value="0">Select Gender</option>
                      <option *ngFor="let item of gender" [value]="item.DICTIONARYID">
                        {{ item.DICTIONARYNAME }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label for="dob" class="form-label">Date of Birth <span class="text-danger">*</span></label>
                    <div class="d-flex gap-2">
                      <select class="form-select" id="dobDay" [(ngModel)]="selectedDay"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let day of days" [value]="day">
                          {{ day }}
                        </option>
                        <!-- Days 1-31 options -->
                      </select>
                      <select class="form-select" id="dobMonth" [(ngModel)]="selectedMonth"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let month of months" [value]="month">
                          {{ month }}
                        </option>
                      </select>
                      <select class="form-select" id="dobYear" (change)="validateAge(); calculateAge()"
                        [(ngModel)]="selectedYear" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let year of years" [value]="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Disability <span class="text-danger">*</span></label>
                    <div>
                      <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" (change)="radioChanged(false)" name="no"
                          id="isDisabilityNo" [checked]="isDisabilityStatus === false" />
                        <label class="form-check-label" for="disabilityNo">No</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" (change)="radioChanged(true)" name="yes"
                          id="isDisabilityYes" [checked]="isDisabilityStatus === true" />
                        <label class="form-check-label" for="disabilityYes">Yes</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 pt-2" *ngIf="showDropdown">
                    <label for="firstName" class="form-label">Type of disability
                      <span class="text-danger">*</span></label>
                    <select class="form-select" (change)="dropdownChanged($event.target.value)"
                      formControlName="type_of_disability">
                      <option value="">Select Disablity</option>
                      <option value="1">Visual Impairment</option>
                      <option value="2">Hearing Impairment</option>
                      <option value="3">Physical disability (mobility)</option>
                      <option value="4">Speech impairment</option>
                      <option value="5">Learning disability</option>
                      <option value="6">Mental health condition</option>
                      <option value="7">Chronic illness</option>
                      <option value="8">Other (please specify)</option>
                    </select>
                  </div>
                  <div class="col-md-4 pt-2" *ngIf="showReasonTextbox">
                    <label for="firstName" class="form-label">Reason for other
                      <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="disability_description"
                      placeholder="Please provide a reason" />
                  </div>
                </div>

                <h6 class="mb-2 mt-3 title_stepper">Address</h6>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="country" class="form-label">Country of Residence
                      <span class="text-danger">*</span></label>
                    <select class="form-select" id="country" (change)="
                        changeCountry(
                          $any($event.target)?.value,
                          'personalDetailsCountry'
                        )
                      " formControlName="COUNTRY_ID">
                      <option value="0">Select</option>
                      <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                        {{ item.COUNTRY_NAME }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4" *ngIf="countyDrpdown">
                    <label for="country" class="form-label">County <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="COUNTIES_ID">
                      <!-- (change)="subCounties($any($event.target).value)" -->
                      <option value="">Select</option>
                      <option *ngFor="let item of County" [value]="item.COUNTIES_CODE">
                        {{ item.COUNTIES_NAME }}
                      </option>
                    </select>
                  </div>
                </div>
                <h6 class="mb-2 mt-3 title_stepper">Contact Information</h6>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="mobileNumber" class="form-label">Mobile Number <span
                        class="text-danger">*</span></label>
                    <div class="d-flex gap-2">
                      <!-- <select
                        class="form-select small-width"
                        id="712455789"
                        formControlName="MOBILENO_CODE_ID"
                        [(ngModel)]="countryCode"
                      >
                        <option
                          *ngFor="let item of country"
                          [value]="item.COUNTRY_ID"
                        >
                          {{ item.COUNTRY_CONNECTING_CODE }}
                        </option>
                      </select> -->
                      <ng-select [items]="country" bindLabel="COUNTRY_CONNECTING_CODE" bindValue="COUNTRY_ID"
                        [(ngModel)]="countryCode" [searchable]="true" formControlName="MOBILENO_CODE_ID"
                        class="form-control">
                      </ng-select>
                      <input class="form-control large-width_1" type="text" id="712455789" placeholder="712455789"
                        formControlName="MOBILENO" (blur)="mobileValidation($event, 1)"
                        (keypress)="onKeyPress($event, 1)" (paste)="onPaste($event, 1)" maxlength="12" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                    <input type="email" class="form-control" id="email" disabled
                      [value]="userDetails?.result?.username" />
                  </div>
                </div>
              </form>

              <div class="text-end">
                <button type="button" class="btn btn-secondary" (click)="previousStep()">
                  Previous
                </button>
                <button type="submit" class="btn btn-primary" (click)="savePersonalDetails(signUpForm)">
                  Next
                </button>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="currentStep === 2">
            <!-- Academic Background -->
            <form>
              <form class="form-container cst_1 cstm_stepper" [formGroup]="signUpForm">
                <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                  Fill in your academic details
                  <strong>Note: Fields marked with an asterisk (<span class="text-danger">*</span>) are
                    mandatory</strong>
                </div>
                <div *ngIf="apptype == 1">
                  <h6 class="mb-2 mt-3 title_stepper">
                    High and Secondary School
                  </h6>
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <label for="Institution_Name" class="form-label">School Name <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="Institution_Name" placeholder="Institution Name"
                        [(ngModel)]="INSTITUTION_NAME" [ngModelOptions]="{ standalone: true }"
                        onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="country" class="form-label">Country of Institution<span class="text-danger">*</span>
                      </label>
                      <select class="form-select" id="country" [(ngModel)]="EDUCATION_COUNTRY_ID"
                        [ngModelOptions]="{ standalone: true }">
                        <option value="">Select</option>
                        <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                          {{ item.COUNTRY_NAME }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="Examination_Number" class="form-label">Exam Index Number<span
                          class="text-danger">*</span>(where applicable)</label>
                      <input type="text" class="form-control" id="Examination_Number"
                        placeholder="e.g KCSE Index Number" [(ngModel)]="EXAM_REG_NO"
                        [ngModelOptions]="{ standalone: true }" />
                      <!-- <div class="form-text">e.g KCSE Index Number</div> -->
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="Qualifications_Attained" class="form-label">Qualifications Type
                        <span class="text-danger">*</span></label>
                      <select (change)="
                          yearValidate($any($event.target).value);
                          clearOther($any($event.target).value)
                        " class="form-select" [(ngModel)]="QUALIFICATION_ID" [ngModelOptions]="{ standalone: true }">
                        <option value="">Select</option>
                        <option *ngFor="let item of qualificationAttained" [value]="item.QUALIFICATION_ATTAINED_ID">
                          {{ item.QUALIFICATION_ATTAINED_NAME }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="End_Year" class="form-label">Year of Completion
                        <span class="text-danger">*</span></label>
                      <select class="form-select" id="End_Year" [(ngModel)]="selectedYearEnd"
                        (change)="generateDropdowns(); validateDateRange('edu')"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let year of years" [value]="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="Mean_Grade" class="form-label">Mean Grade<span class="text-danger">*</span></label>
                      <select class="form-select" id="Mean_Grade" [(ngModel)]="MEAN_GRADE"
                        [ngModelOptions]="{ standalone: true }">
                        <option value="">Select Grade</option>
                        <option *ngFor="let item of grades" [value]="item.AMT_ID">
                          {{ item.GRADE }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="formFile" class="form-label">Certificate/ Result Slip<span
                          class="text-danger">*</span></label>
                      <div class="custom-file-group">
                        <input type="file" [(ngModel)]="UPLOAD_1" [ngModelOptions]="{ standalone: true }"
                          (change)="changeFile($event, 1)" class="form-control" #fileInputRefupload1 />
                        <button class="remove-btn" id="basic-addon2" (click)="removeFile('1')">
                          <span class="thick-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-x-square" viewBox="0 0 16 16">
                              <path
                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                              <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                            </svg>
                          </span>
                        </button>
                        <!-- <span
                                  class="input-group-text btn btn-sm btn-light"
                                  style="
                                    cursor: pointer;

                                    color: #ff7f50;
                                  "
                                  id="basic-addon2"
                                  (click)="removeFile('1')"
                                  ><i class="bi bi-x fs-4"></i
                                ></span> -->
                      </div>
                      <div class="text-blue">
                        <small>Upload your academic certificates. Files must be in
                          PDF format only (Please upload all certificates as a
                          single, combined PDF file)</small>
                      </div>
                      <p *ngIf="upload_1 != ''">
                        {{ upload_1 }}
                      </p>
                      <div *ngIf="isProgressTwo" class="progress my-3">
                        <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                          attr.aria-valuenow="{{ progressTwo }}" aria-valuemin="0" aria-valuemax="100"
                          [ngStyle]="{ width: progressTwo + '%' }">
                          {{ progressTwo }}%
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center pt-2" *ngIf="educationData.length === 0 || isEditeducation">
                    <button type="button" class="btn btn-save" (click)="add()">
                      Save
                    </button>
                  </div>
                  <div class="table-wrapper pt-4" *ngIf="educationData.length">
                    <div class="table-responsive">
                      <table class="table education-table table-sm table-borderless">
                        <thead class="edu-thead">
                          <tr>
                            <th>Institution</th>
                            <th>Country</th>
                            <th>Qualifications</th>
                            <th>Year</th>
                            <th>Index Number</th>
                            <th>Grade</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of educationData; let i = index">
                            <td>{{ row?.INSTITUTION_NAME }}</td>
                            <td>{{ row?.EDUCATION_COUNTRY }}</td>
                            <td>
                              <ng-container *ngIf="row.QUALIFICATION == ''">
                                <select class="form-select form-select-sm readonly-dropdown" disabled
                                  [(ngModel)]="row.QUALIFICATION_ID" [ngModelOptions]="{
                                    standalone: true
                                  }">
                                  <option value="">Select</option>
                                  <option *ngFor="let item of qualificationAttained"
                                    [value]="item.QUALIFICATION_ATTAINED_ID">
                                    {{ item.QUALIFICATION_ATTAINED_NAME }}
                                  </option>
                                </select>
                              </ng-container>
                              <ng-container *ngIf="row.QUALIFICATION != ''">
                                <div class="readonly-input">
                                  {{ row.QUALIFICATION }}
                                </div>
                              </ng-container>
                            </td>
                            <td>{{ row?.TOPERIOD_YEAR }}</td>
                            <td>
                              {{ row?.EXAM_REG_NO }}
                            </td>
                            <td>
                              {{ row?.GRADE }}
                            </td>
                            <td>
                              <button class="btn btn-save btn-sm" (click)="editdata(row, 'edu')">
                                Edit
                              </button>
                              <button class="btn btn-danger btn-sm" (click)="remove(i)">
                                Remove
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-center" *ngIf="!educationData.length">
                    No Records to display
                  </div>
                  <span class="pt-4">
                    <h6 class="mb-2 mt-3 title_stepper">
                      Recognition of Prior Learning or Other Qualifications
                      <span class="tooltip-icon">
                        <i class="fas fa-info-circle"></i>
                        <span class="tooltip-text" style="font-weight: 100">Did you miss out on university placement due
                          to your
                          past grades and now wish to be considered for
                          admission based on your previous training and
                          experience?</span>
                      </span>
                    </h6>
                    <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                      <strong>
                        Did you miss a university placement because of your
                        grades? We can consider your application based on your
                        previous training and experience instead. This is part
                        of Recognition of Prior Learning at OUK</strong>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Are you applying for Recognition of Prior Learning
                          (RPL)?
                          <span class="text-danger">*</span>
                          <!-- <span class="tooltip-icon">
                                    <i class="fas fa-info-circle"></i>
                                    <span
                                      class="tooltip-text"
                                      style="font-weight: 100"
                                      >Did you miss out on university placement
                                      due to your past grades and now wish to be
                                      considered for admission based on your
                                      previous training and experience?</span
                                    >
                                  </span> -->
                        </label>
                        <div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="rpl" id="RPLNo" [value]="false"
                              [checked]="IS_RPL === false" (change)="showportfolio(false)" />
                            <label class="form-check-label" for="RPLNo">No</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="rpl" id="RPLYes" [value]="true"
                              [checked]="IS_RPL === true" (change)="showportfolio(true)" />
                            <label class="form-check-label" for="RPLYes">Yes</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isUploadPortfolio">
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <label for="Institution_Name" class="form-label">Institution Name
                            <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" id="Institution_Name" placeholder="Institution Name"
                            [(ngModel)]="RPL_INSTITUTION_NAME" [ngModelOptions]="{ standalone: true }"
                            onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                        </div>
                        <div class="col-md-4 mb-3">
                          <label for="country" class="form-label">Country of Institution<span
                              class="text-danger">*</span>
                          </label>
                          <select class="form-select" id="country" [(ngModel)]="RPL_EDUCATION_COUNTRY_ID"
                            [ngModelOptions]="{ standalone: true }">
                            <option value="">Select</option>
                            <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                              {{ item.COUNTRY_NAME }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-4 mb-3">
                          <label for="Qualifications_Attained" class="form-label">Qualifications Type
                            <span class="text-danger">*</span></label>
                          <select (change)="
                              yearValidate($any($event.target).value);
                              clearOther($any($event.target).value)
                            " class="form-select" [(ngModel)]="RPL_QUALIFICATION_ID"
                            [ngModelOptions]="{ standalone: true }">
                            <option value="">Select</option>
                            <!-- <option
                              *ngFor="let item of qualificationAttained"
                              [value]="item.QUALIFICATION_ATTAINED_ID"
                            >
                              {{ item.QUALIFICATION_ATTAINED_NAME }}
                            </option> -->
                            <option value="1">Certificate</option>
                            <option value="2">Diploma</option>
                            <option value="3">RPL Certification</option>
                          </select>
                        </div>
                        <div class="col-md-4 mb-3">
                          <label for="End_Year" class="form-label">Year of Completion
                            <span class="text-danger">*</span></label>
                          <select class="form-select" id="End_Year" [(ngModel)]="RPL_TOPERIOD_YEAR" (change)="
                              generateDropdowns(); validateDateRange('edu')
                            " [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let year of years" [value]="year">
                              {{ year }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-6 mb-3">
                          <label for="formFile" class="form-label">Certificate<span class="text-danger">*</span></label>
                          <div class="custom-file-group">
                            <input type="file" formControlName="UPLOAD_3" (change)="changeFile($event, 3)"
                              class="form-control" #fileInputRef />

                            <button class="remove-btn" id="basic-addon2" (click)="removeFile('2')">
                              <span class="thick-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  class="bi bi-x-square" viewBox="0 0 16 16">
                                  <path
                                    d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                                  <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                              </span>
                            </button>
                          </div>
                          <div class="text-blue">
                            <small>
                              Combine post-secondary certificates (e.g.,
                              Certificate, Diploma, RPL Certification) in a
                              single PDF file</small>
                          </div>
                          <p *ngIf="upload_3 != ''">
                            {{ upload_3 }}
                          </p>
                          <div *ngIf="isProgressThree" class="progress my-3">
                            <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                              attr.aria-valuenow="{{ progressThree }}" aria-valuemin="0" aria-valuemax="100"
                              [ngStyle]="{ width: progressThree + '%' }">
                              {{ progressThree }}%
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pt-2">
                        <div class="text-center">
                          <button type="button" class="btn btn-save" (click)="addRPlData()"
                            *ngIf="rplData.length === 0 || isEdit">
                            Add
                          </button>
                        </div>
                        <div class="table-wrapper pt-2" *ngIf="rplData.length">
                          <div class="table-responsive">
                            <table class="table education-table table-sm table-borderless">
                              <thead class="edu-thead">
                                <tr>
                                  <th>Institution</th>
                                  <th>Country</th>
                                  <th>Qualifications</th>
                                  <th>Year</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of rplData; let i =index">
                                  <td>{{ row?.INSTITUTION_NAME }}</td>
                                  <td>
                                    {{
                                    row?.RPL_EDUCATION_COUNTRY ||
                                    row?.EDUCATION_COUNTRY
                                    }}
                                  </td>
                                  <td>
                                    <select class="form-select form-select-sm readonly-dropdown" disabled
                                      [(ngModel)]="row.QUALIFICATION_ID" [ngModelOptions]="{
                                        standalone: true
                                      }">
                                      <option value="">Select</option>
                                      <option value="1">Certificate</option>
                                      <option value="2">Diploma</option>
                                      <option value="3">
                                        RPL Certification
                                      </option>
                                      <!-- <option
                                        *ngFor="
                                          let item of qualificationAttained
                                        "
                                        [value]="item.QUALIFICATION_ATTAINED_ID"
                                      >
                                        {{ item.QUALIFICATION_ATTAINED_NAME }}
                                      </option> -->
                                    </select>
                                  </td>
                                  <td>{{ row?.TOPERIOD_YEAR }}</td>
                                  <td>
                                    <button class="btn btn-save btn-sm" (click)="editRpldata(row)">
                                      Edit
                                    </button>
                                    <button class="btn btn-danger btn-sm" (click)="removeRpl(i)">
                                      Remove
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="text-center" *ngIf="!rplData.length">
                          No Records to display
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
                <!-- //PG -->
                <div *ngIf="[2, 7, 5, 4, 6].includes(apptype)">
                  <h6 class="mb-2 mt-3 title_stepper">
                    {{
                    [2, 7, 5, 6, 4].includes(apptype)
                    ? "Bachelor Degree Qualification"
                    : " Master Degree Qualification"
                    }}
                  </h6>
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <label for="Institution_Name" class="form-label">Awarding Institution
                        <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="Institution_Name" placeholder="Institution Name"
                        [(ngModel)]="INSTITUTION_NAME" [ngModelOptions]="{ standalone: true }"
                        onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="country" class="form-label">Country of Institution<span class="text-danger">*</span>
                      </label>
                      <select class="form-select" id="country" [(ngModel)]="EDUCATION_COUNTRY_ID"
                        [ngModelOptions]="{ standalone: true }">
                        <option value="">Select</option>
                        <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                          {{ item.COUNTRY_NAME }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="Start_Year" class="form-label">Start Year <span class="text-danger">*</span></label>
                      <select class="form-select" id="Start_Year" [(ngModel)]="selectedYearStart" (change)="
                          generateDropdowns();
                          clearMonthDayWrk('start', 'edu');
                          validateDateRange('edu')
                        " [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let year of years" [value]="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="End_Year" class="form-label">End Year <span class="text-danger">*</span></label>
                      <select class="form-select" id="End_Year" [(ngModel)]="selectedYearEnd"
                        (change)="generateDropdowns(); validateDateRange('edu')"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let year of years" [value]="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="DEGREE_OBTAINED" class="form-label">Degree Obtained
                        <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="DEGREE_OBTAINED"
                        placeholder="eg. Bachelor of Education (BEd)" [(ngModel)]="DEGREE_OBTAINED"
                        [ngModelOptions]="{ standalone: true }"
                        onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="formFile" class="form-label">
                        Attach Bachelor Degree Certificate<span class="text-danger">*</span></label>
                      <div class="custom-file-group">
                        <input type="file" [(ngModel)]="UPLOAD_1" [ngModelOptions]="{ standalone: true }"
                          (change)="changeFile($event, 1)" class="form-control" #fileInputRefupload1 />
                        <button class="remove-btn" id="basic-addon2" (click)="removeFile('1')">
                          <span class="thick-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-x-square" viewBox="0 0 16 16">
                              <path
                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                              <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                            </svg>
                          </span>
                        </button>
                        <!-- <span
                                  class="input-group-text btn btn-sm btn-light"
                                  style="
                                    cursor: pointer;

                                    color: #ff7f50;
                                  "
                                  id="basic-addon2"
                                  (click)="removeFile('1')"
                                  ><i class="bi bi-x fs-4"></i
                                ></span> -->
                      </div>
                      <!-- <div class="text-blue">
                              <small
                                >Upload your academic certificates. Files must
                                be in PDF format only (Please upload all
                                certificates as a single, combined PDF
                                file)</small
                              >
                            </div> -->
                      <p *ngIf="upload_1 != ''">
                        {{ upload_1 }}
                      </p>
                      <div *ngIf="isProgressTwo" class="progress my-3">
                        <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                          attr.aria-valuenow="{{ progressTwo }}" aria-valuemin="0" aria-valuemax="100"
                          [ngStyle]="{ width: progressTwo + '%' }">
                          {{ progressTwo }}%
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center pt-2">
                    <button type="button" class="btn btn-save" (click)="add()">
                      {{
                      educationData.length
                      ? "Add Other Institution"
                      : "Add and Save"
                      }}
                    </button>
                  </div>
                  <div class="table-wrapper pt-2" *ngIf="educationData.length">
                    <div class="table-responsive">
                      <table class="table education-table table-sm table-borderless">
                        <thead class="edu-thead">
                          <tr>
                            <th>Institution</th>
                            <th>Country</th>
                            <th>Degree Obtained</th>
                            <th>Start Year</th>
                            <th>End Year</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of educationData; let i = index">
                            <td>{{ row?.INSTITUTION_NAME }}</td>
                            <td>
                              {{ row?.EDUCATION_COUNTRY }}
                            </td>
                            <td>{{ row?.DEGREE_OBTAINED }}</td>
                            <td>{{ row?.FROMPERIOD_YEAR }}</td>
                            <td>{{ row?.TOPERIOD_YEAR }}</td>
                            <td>
                              <button class="btn btn-save btn-sm" (click)="editdata(row, 'edu')">
                                Edit
                              </button>
                              <button class="btn btn-danger btn-sm" (click)="remove(i)">
                                Remove
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-center" *ngIf="!educationData.length">
                    No Records to display
                  </div>
                </div>
              </form>

              <div class="text-end pt-2">
                <button type="button" class="btn btn-secondary" (click)="previousStep()">
                  Previous
                </button>
                <button type="submit" class="btn btn-primary" (click)="saveEducationData(signUpForm)"
                  [disabled]="!educationData.length">
                  Next
                </button>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="apptype != '1' && currentStep === 3">
            <form *ngIf="isRecommondations">
              <form class="form-container cstm_stepper">
                <h6 class="mb-2 mt-3 title_stepper">Recommendations</h6>

                <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                  Please consider providing details for your academic referees
                  in this section. Although optional, this information is highly
                  recommended as it helps to validate and support your
                  application.
                </div>
                <h6 class="mb-2 mt-3 title_stepper" style="color: #f47d52 !important">
                  Referee 1
                </h6>

                <div class="row pt-2">
                  <div class="col-md-4 mb-3">
                    <label for="Full_Name:" class="form-label">Full Name<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span>:
                    </label>
                    <input type="text" class="form-control" id="Full_Name:" placeholder="Full Name:" [(ngModel)]="NAME1"
                      onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="Organization:" class="form-label">Institution<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="Organization" placeholder="Institution:"
                      onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" [(ngModel)]="ORGANIZATION1"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Country<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span>:</label>
                    <select class="form-select" [(ngModel)]="COUNTRY_ID1" [ngModelOptions]="{ standalone: true }"
                      (change)="getMobileCode(1)">
                      <option value="0">Select</option>
                      <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                        {{ item.COUNTRY_NAME }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="City_Town" class="form-label">Mobile Number<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span></label>
                    <div class="d-flex gap-2">
                      <select style="min-width: 96px; max-width: 120px" class="form-select" disabled
                        [(ngModel)]="MOBILENO_CODE_ID1" [ngModelOptions]="{ standalone: true }">
                        <option value="0">Select</option>
                        <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                          {{ item.COUNTRY_CONNECTING_CODE }}
                        </option>
                      </select>
                      <!-- <ng-select
                                [items]="country"
                                bindLabel="COUNTRY_CONNECTING_CODE"
                                bindValue="COUNTRY_ID"
                                [(ngModel)]="MOBILENO_CODE_ID1"
                                [ngModelOptions]="{ standalone: true }"
                                [searchable]="true"
                                class="form-control"
                                [disabled]="true"
                              >
                              </ng-select> -->
                      <input class="form-control large-width" type="text" id="712455789"
                        (keypress)="onKeyPress($event, 4)" maxlength="12" [(ngModel)]="MOBILE_NUMBER1"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="Recommender_email" class="form-label">Referee email<span
                        *ngIf="[5, 7].includes(apptype)" class="text-danger">*</span></label>
                    <input class="form-control" type="email" id="Recommender_email" placeholder="Recommender email"
                      (change)="validateEmail($event, 'sponserEmail1')" [(ngModel)]="EMAIL_ADDRESS1"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                </div>
                <h6 class="mb-2 mt-3 title_stepper" style="color: #f47d52 !important">
                  Referee 2
                </h6>

                <div class="row pt-2">
                  <div class="col-md-4 mb-3">
                    <label for="Full_Name:" class="form-label">Full Name<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span>:
                    </label>
                    <input type="text" class="form-control" id="Full_Name:" placeholder="Full Name:" [(ngModel)]="NAME2"
                      onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="Organization:" class="form-label">Institution<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="Organization" placeholder="Institution:"
                      onkeypress="return /[a-a-zA-Z'-'\s]/i.test(event.key)" [(ngModel)]="ORGANIZATION2"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label">Country<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span>:</label>

                    <select class="form-select" [(ngModel)]="COUNTRY_ID2" [ngModelOptions]="{ standalone: true }"
                      (change)="getMobileCode(2)">
                      <option value="0">Select</option>
                      <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                        {{ item.COUNTRY_NAME }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="City_Town" class="form-label">Mobile Number<span *ngIf="[5, 7].includes(apptype)"
                        class="text-danger">*</span></label>
                    <div class="d-flex gap-2">
                      <select class="form-select" style="min-width: 96px; max-width: 120px" disabled
                        [(ngModel)]="MOBILENO_CODE_ID2" [ngModelOptions]="{ standalone: true }">
                        <option value="0">Select</option>
                        <option *ngFor="let item of country" [value]="item.COUNTRY_ID">
                          {{ item.COUNTRY_CONNECTING_CODE }}
                        </option>
                      </select>
                      <input class="form-control large-width" type="text" id="712455789"
                        (keypress)="onKeyPress($event, 4)" maxlength="12" [(ngModel)]="MOBILE_NUMBER2"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="Recommender_email" class="form-label">Referee email<span
                        *ngIf="[5, 7].includes(apptype)" class="text-danger">*</span></label>
                    <input class="form-control" type="email" id="Recommender_email" placeholder="Recommender email"
                      (change)="validateEmail($event, 'sponserEmail2')" [(ngModel)]="EMAIL_ADDRESS2"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                </div>
              </form>

              <div class="text-end pt-2">
                <button type="button" class="btn btn-secondary" (click)="previousStep()">
                  Previous
                </button>
                <button type="submit" class="btn btn-primary" (click)="saveRecommondationData()">
                  Next
                </button>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="currentStep === (apptype != '1' ? 4 : 3)">
            <!-- Review and Submit -->
            <form class="form-container cstm_stepper">
              <div class="bg-light p-2 border border-secondary-subtle rounded mb-3">
                Get a chance to go through everything you ve filled in. It s
                your final step to ensure accuracy before officially submitting
                your application.
              </div>
              <div>
                <strong>Note: Fields marked with an asterisk (<span class="text-danger">*</span>) are mandatory</strong>
              </div>
              <div class="row">
                <div class="col-md-3 mb-3">
                  <label for="dob" class="form-label">Referral Code </label>
                  <input type="text" disabled class="form-control" [value]="userDetails?.result?.referral_code" />
                </div>

                <div class="col-md-6 mb-3">
                  <label for="dob" class="form-label">How did you hear about OUK?<span class="text-danger">*</span>
                  </label>
                  <select [(ngModel)]="selectedReferral" [ngModelOptions]="{ standalone: true }"
                    (change)="changeReferral($any($event.target)?.value)" class="form-select">
                    <option value="">Select</option>
                    <option *ngFor="let item of referrals" [value]="item.REF_SOCIALMEDIA_ID">
                      {{ item.REF_NAME }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <label for="Recommender_email" class="form-label">Save and Review</label>
                <div style="
                    background-color: #d1d1d6;
                    text-align: center;
                    padding: 30px;
                    margin-bottom: 5px;
                  ">
                  <button type="submit" class="btn btn-save" (click)="update(signUpForm, 2)">
                    Save and Review
                  </button>
                </div>
                <div style="background-color: #f0f9ff; padding: 5px">
                  <span>NOTE: Remember that once you submit your application you
                    cannot make any additional changes or view the
                    application</span>
                </div>
              </div>
            </form>
            <div class="text-end pt-2">
              <button type="button" class="btn btn-secondary" (click)="previousStep()">
                Previous
              </button>
              <button type="button" class="btn btn-save" data-bs-toggle="modal" data-bs-target="#previewModal"
                (click)="update(signUpForm, 4)" *ngIf="userDetails?.result?.is_submit != 5 && aprvId != 4">
                Update
              </button>
              <button type="button" class="btn btn-info" (click)="update(signUpForm, 8)"
                *ngIf="userDetails?.result?.is_submit == 5 && aprvId == 4">
                Enroll
              </button>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" id="updateClose" data-bs-dismiss="modal">
          <!-- (click)="closeRegistrationPopup(false)" -->

          Close
        </button>
        <!-- <button type="button" class="btn btn-info  " [disabled]="userDetails?.result?.is_submit==3"
                    (click)="update(signUpForm,4)"
                    *ngIf="userDetails?.result?.is_submit!=5 && aprvId != 4">Update</button>
                <button type="button" class="btn btn-info  " (click)="update(signUpForm,8)"
                    *ngIf="userDetails?.result?.is_submit==5 && aprvId == 4">Enroll</button> -->
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="finalPopup" tabindex="-1" aria-labelledby="finalPopupLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-body">
        <!-- Title and badge -->
        <div class="d-flex justify-content-between align-items-start mb-3">
          <h5 class="fw-bold">Application Successfully Submitted</h5>
          <span class="badge bg-success">Submitted</span>
        </div>

        <!-- New Acknowledgment Message -->
        <p>
          Dear
          <strong>{{ userDetails?.result?.firstname }}
            {{ userDetails?.result?.lastname }}</strong>,
        </p>
        <p class="pt-2">
          We have received your application for admission into the
          <strong>{{ userDetails?.result?.course_name }}</strong> Programme at
          the Open University of Kenya.
        </p>
        <p class="pt-2"><strong>Application details:</strong></p>
        <ul class="mb-3">
          <li>
            <strong>Application Reference Number:</strong>
            {{ userDetails?.result?.ref_code }}
          </li>
          <li>
            <strong>Programme Applied for:</strong>
            {{ userDetails?.result?.course_name }}
          </li>
          <li>
            <strong>Application Date:</strong>
            {{ userDetails?.result?.createddate | date : "dd-MM-yyyy" }}
          </li>
          <li><strong>Status:</strong> Submitted</li>
        </ul>

        <p class="pt-2">
          The admissions team will review your application, and you will be
          notified of the decision soon via email (<a [href]="'mailto:' + userDetails?.result?.username">{{
            userDetails?.result?.username }}</a>).
        </p>
        <p class="pt-2">
          If you have any questions, please contact us at
          <a href="mailto:admissions&#64;ouk.ac.ke">admissions&#64;ouk.ac.ke</a>.
        </p>
        <p class="pt-2">Thank you for considering OUK for your education.</p>

        <!-- Footer button -->
        <div class="text-end pt-2">
          <button class="btn btn-save" data-bs-dismiss="modal" aria-label="Close">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" data-backdrop="static" data-keyboard="false" id="admissionForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Admission Letter</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <iframe *ngIf="admissionLetter" [src]="admissionLetter" width="100%" height="600px"
          style="border: none"></iframe>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" id="admsionForm" data-bs-dismiss="modal">
          Close</button>&nbsp;&nbsp;
        <button class="btn btn-save" (click)="downloadForm('admissionletter')">
          Download
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="finalPopupforAdmission" tabindex="-1" aria-labelledby="finalPopupforAdmissionLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-body">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <h5 class="fw-bold">Admission Accepted</h5>
        </div>

        <!-- Updated Message -->
        <p>
          Dear <strong>{{ userName }}</strong>,
        </p>
        <p>
          You have accepted the admission offer letter into the Open University
          of Kenya for the programme -
          <strong>{{ table[0]?.COURSE_NAME }}</strong>.
        </p>
        <p>
          Please check your email
          <a [href]="'mailto:' + emailId">{{ emailId }}</a> for your student
          login credentials and follow the instructions as shared.
        </p>
        <p>Thank you.</p>
        <p class="fw-bold text-danger mb-0">
          Note:
          <span class="fw-normal text-dark">Please check your Spam Folder if you are unable to find the email
            in your primary folder.</span>
        </p>

        <!-- Footer button -->
        <div class="text-end pt-2">
          <button class="btn btn-save" data-bs-dismiss="modal" aria-label="Close">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>